import React from 'react'

const SeoSection = () => {
    return(
        <section className="seo-section py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
            <h1 className="text-3xl font-bold text-[#252A32] mb-6">
            Best Lift & Elevator Manufacturers in Kerala
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-10">
            Becone Elevators leads as a trusted lift and elevator manufacturer in Kerala,
            offering home lifts, passenger elevators, customized solutions, installation,
            AMC, and modernization services with BIS safety compliance.
            </p>
        </div>

        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-10">
            <div className="seo-card">
            <h2 className="text-2xl font-semibold text-[#B8956B] mb-3">
                🚀 Trusted Elevator Company in Kerala
            </h2>
            <p className="text-gray-600">
                With 30+ years of industry experience, we deliver end-to-end solutions for
                residential and commercial elevator needs across Kerala.
            </p>
            </div>

            <div className="seo-card">
            <h2 className="text-2xl font-semibold text-[#B8956B] mb-3">
                🏠 Home Lift Manufacturers in Kerala
            </h2>
            <p className="text-gray-600">
                Specializing in premium home lifts designed for modern homes — elegant,
                safe, smooth, and built to elevate your everyday living experience.
            </p>
            </div>

            <div className="seo-card">
            <h2 className="text-2xl font-semibold text-[#B8956B] mb-3">
                ⚙️ Customized Elevator Solutions
            </h2>
            <p className="text-gray-600">
                Tailored elevator systems for unique architectural needs — from design to
                execution with quality and safety in focus.
            </p>
            </div>

            <div className="seo-card">
            <h2 className="text-2xl font-semibold text-[#B8956B] mb-3">
                📍 Services Across Kerala
            </h2>
            <p className="text-gray-600">
                We serve Kochi, Ernakulam, Thrissur, Kottayam, Trivandrum, Calicut and
                all major regions of Kerala with reliable elevator support.
            </p>
            </div>
        </div>
        </section>

    );
}

export default SeoSection;